import script from "./ProjectAttachmentListComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./ProjectAttachmentListComponent.vue?vue&type=script&setup=true&lang=js"

import "./ProjectAttachmentListComponent.vue?vue&type=style&index=0&id=3eb1f186&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3eb1f186"]])

export default __exports__